import React from 'react';
import { StyledComponentProps, withStyles } from '@material-ui/core';
import { IconButton as MuiButton } from '@material-ui/core';
import { styles } from './styles';
import { ReactComponent as Send } from '../../images/icons/pubblica.svg';

interface IProps extends StyledComponentProps {
    onClick: () => any;
    disabled?: boolean;
}

const DeleteButton = (props: IProps) => {
    return (<MuiButton
        disabled={props.disabled}
        className={props.classes.iconButtonRootSvgBlack}
        onClick={props.onClick}>
        <Send className={props.classes.iconButtonSvgBlack} />
    </MuiButton>)
}


export default withStyles(styles)(DeleteButton)